import React, { memo } from 'react';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = ['Las libretas de contraseñas no sirven para los códigos de seguridad (SMS) que llegan al celular en tiempo real.', "Decirle a un hijo 'tú ya sabes mis claves' falla porque las claves cambian y la memoria es frágil ante el luto.", 'Los abogados de sucesiones tradicionales rara vez entienden el acceso técnico a cuentas de iCloud, Google o Zelle.', 'Los gestores de contraseñas complejos son tan difíciles de usar que tu familia se rendirá antes de lograr entrar.'];
  return <section className="bg-navy text-white-soft section-padding rounded-3xl my-12 mx-4 md:mx-auto shadow-2xl" data-id="element-49">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-white" data-id="element-50">
        Por qué lo que has intentado no funciona
      </h2>

      <div className="space-y-6 max-w-3xl mx-auto" data-id="element-51">
        {failures.map((failure, index) => <div key={index} className="flex items-start bg-navy-dark p-6 rounded-lg border border-white/5" data-id="element-52">
            <XCircle className="w-8 h-8 text-red-400 mr-4 flex-shrink-0 mt-1" data-id="element-53" />
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-54">
              {failure}
            </p>
          </div>)}
      </div>
    </section>;
}